// Modal body for managing push-notification permission and opt-in.

import { useState } from 'react';
import { toast } from 'react-toastify';
import CheckBox from './CheckBox';
import {
  getNotificationPermission,
  enableNotifications,
  disableNotifications,
} from '../utils/notifications';
import './NotificationsModalBody.scss';

export default function NotificationsModalBody() {
  const [permission, setPermission] = useState(getNotificationPermission());
  const [enabled, setEnabled] = useState(permission === 'granted');
  const [loading, setLoading] = useState(false);

  const handleToggle = async (value) => {
    setLoading(true);
    try {
      if (value) {
        await enableNotifications();
        toast.success('Notifications enabled');
        setEnabled(true);
      } else {
        await disableNotifications();
        toast.success('Notifications disabled');
        setEnabled(false);
      }
    } catch (error) {
      toast.error(error?.message ?? 'Failed to update notifications');
    } finally {
      setPermission(getNotificationPermission());
      setLoading(false);
    }
  };

  if (permission === 'unsupported')
    return (
      <p className='notifications-modal font-16'>
        Push notifications are not supported on this device or browser.
      </p>
    );

  return (
    <div className='notifications-modal'>
      <CheckBox
        label='Push notifications for new messages'
        value={enabled}
        onChange={handleToggle}
        disabled={loading || permission === 'denied'}
      />
      {permission === 'denied' && (
        <p className='hint font-14'>
          Notifications are blocked. To enable them, allow notifications for
          this site in your browser/OS settings, then reload the page.
        </p>
      )}
    </div>
  );
}
